import { FetchBookingParams, ListData, Booking } from "@/types";
import axiosInstance from "./api";

export function fetchListBookingService(
  params: FetchBookingParams,
): Promise<ListData<Booking>> {
  return axiosInstance
    .get("/reward/admin/booking", { params })
    .then((response) => response.data);
}
